import React from 'react';

import { MatrizConsultaProvider } from './context';
import { MatrizConsulta } from './MatrizConsulta';

export function MatrizConsultaModule() {
  return <MatrizConsultaProvider>
    <MatrizConsulta />
         </MatrizConsultaProvider>;
}
